import Section from 'components/common/Section';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import ADSelectDonor from './add-donation-components/ADSelectDonor';
import PNDonationSummary from './add-donation-components/PNDonationSummary';
import PNPaymentOption from './add-donation-components/PNPaymentOption';

const PayNow = () => {
  return (
    <Section className={'py-0'}>
      <Form>
        <Row className="g-3">
          <Col md={8} className="order-1 order-md-0">
            <ADSelectDonor editable={false} title="Selected Donor(s)" />
            <PNPaymentOption />
          </Col>
          <Col md={4} className="order-0 order-md-1">
            <PNDonationSummary />
          </Col>
        </Row>
      </Form>
    </Section>
  );
};

export default PayNow;
